<template>
  <div class="time-estimate">
    <span
      v-if="withIcon"
      class="time-estimate__data-icon iconfont itime"
    ></span>
    <span class="time-estimate__data-text">{{ minutes }} min</span>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import type { DocListItem } from '@/models/interfaces'
import { readingMinutes } from '@/helpers/time'
import { Sentry } from '@/services/sentry'

const props = withDefaults(
  defineProps<{
    doc: Pick<DocListItem, 'id'> & { summary_words?: number | null }
    withIcon?: boolean
  }>(),
  {
    withIcon: true,
  },
)

onMounted(() => {
  if (!props.doc.summary_words) {
    Sentry.withScope((scope) => {
      scope.setExtra('doc_id', props.doc.id)
      Sentry.captureMessage('Doc missing summary_words')
    })
  }
})

const minutes = computed(() => readingMinutes(props.doc.summary_words))
</script>

<style lang="scss" scoped>
.time-estimate {
  display: flex;
  align-items: center;
  border: 1px solid $c-black-4;
  border-radius: 8px;
  color: $c-black-9;
  background-color: $c-bg;
  padding: 2px 8px 0px 8px;

  min-height: 25.5px;

  &__data-icon {
    font-size: 20px;
    line-height: 20px;
    margin-right: 4px;
  }

  &__data-text {
    font-size: 12px;
    line-height: 12px;
  }
}

.night-mode {
  .time-estimate {
    background-color: $c-dark-2;
    border: 1px solid $c-dark-3;
    color: $c-black-6;
  }
}
</style>
